module.exports = __webpack_public_path__ + "img/icon-container.200f8a78.svg";